import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {MatDialog} from '@angular/material/dialog';
import {ManagementDialogComponent} from './management-dialog/management-dialog.component';

@Component({
  selector: 'app-role-action-management',
  templateUrl: './role-action-management.component.html',
  styleUrls: ['./role-action-management.component.scss']
})
export class RoleActionManagementComponent implements OnInit {
  //#region class members
  roles: MatTableDataSource<any> = new MatTableDataSource<any>();
  actions: MatTableDataSource<any> = new MatTableDataSource<any>();
  rolesColumnsToDisplay: string[];
  actionsColumnsToDisplay: string[];
  isRoleLoading: boolean;
  isActionsLoading: boolean;
  tableHeight: number;
  selected: any;
  //#endregion


  //#region Constructor and OnInit
  constructor(private commonService: CommonService, public toastMessagesService: ToastMessagesService, public dialog: MatDialog) {
    this.isRoleLoading = true;
    this.isActionsLoading = true;
    this.rolesColumnsToDisplay = ['role_name', 'role_description', 'actions'];
    this.actionsColumnsToDisplay = ['select', 'description', 'alternate_description'];
    this.tableHeight = window.innerHeight - 400;
  }

  async ngOnInit() {
    await this.initRoles();
    // await this.initActions();
  }

  //#endregion


  //#region async Requests from Server
  async initRoles() {
    this.isRoleLoading = true;
    try {
      const rolesRequest = await this.commonService.getList(`roles`);
      this.roles.data = rolesRequest.object;
    } catch (e) {
      console.log(e.message);
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isRoleLoading = false;
    }
  }

  // async initActions() {
  //   this.isActionsLoading = true;
  //
  //   try {
  //     const actionsRequest = await this.commonService.getList(`actions`);
  //     for (const action of actionsRequest.object) {
  //       action.checked = false;
  //     }
  //     this.actions.data = actionsRequest.object;
  //   } catch (e) {
  //     console.log(e.message);
  //     this.toastMessagesService.toastErrorMessage(e.message);
  //   } finally {
  //     // this.isActionsLoading = false;
  //   }
  // }

  // async updatePrivileges() {
  //   try {
  //     const selectedRole = this.selected;
  //     const appliedActions = this.actions.data.filter(action => action.checked);
  //     console.log(appliedActions);
  //     const updateModel = {
  //       roleId: selectedRole.id,
  //       actions: appliedActions
  //     };
  //
  //     await this.commonService.updateItem('roles/actions', updateModel);
  //     this.toastMessagesService.toastMessages(`Η ενημέρωση του ρόλου ${selectedRole.role_name} ολοκληρώθηκε με επιτυχία.`);
  //   } catch (e) {
  //     this.toastMessagesService.toastErrorMessage(e.message);
  //   }
  // }
  //#endregion


  // async selectionChanged(row: any, event: any) {
  //   if (event.checked) {
  //     this.selected = row;
  //
  //     try {
  //       const appliedActionsRequest = await this.commonService.getList(`roles/actions?roleId=${this.selected.id}`);
  //       const actions = this.actions.data;
  //
  //       if (appliedActionsRequest.object.length > 0) {
  //
  //         this.clearActionsSelection();
  //
  //         for (const appliedAction of appliedActionsRequest.object) {
  //           const action = actions.find(a => a.id === appliedAction.action_id);
  //           if (action) {
  //             action.checked = true;
  //           }
  //         }
  //       } else {
  //        this.clearActionsSelection();
  //       }
  //     } catch (e) {
  //       this.toastMessagesService.toastErrorMessage(e.message);
  //     }
  //   } else {
  //     this.clearActionsSelection();
  //     this.selected = null;
  //   }
  // }

  clearActionsSelection() {
    for (const action of this.actions.data) {
      action.checked = false;
    }
  }

  isRoleSelected() {
    return !this.selected;
  }

  actionSelected(action: any, event: any) {
    action.checked = event.checked;
  }

  managementDialog(role: any, mode: number) {
    this.dialog.open(ManagementDialogComponent, {
      data: {
        role,
        mode
      }
    });
  }
}
